export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      // badge: {
      //   variant: 'primary',
      //   text: 'NEW'
      // }
    },
    {
      name: 'Products',
      url: '/products',
      icon: 'icon-pencil'
    },
    // {
    //   name: 'Settings',
    //   url: '/settings',
    //   icon: 'icon-settings'
    // },
   
  ]
}
